const ApproveReportsForm = {
  fields: {
    comment: {
      type: 'textarea',
      label: 'Comment',
    },
    approve: {
      type: 'boolean',
      label: 'Approve'
    },
  }
};

export {
  ApproveReportsForm
}
